module.exports = __webpack_public_path__ + "static/media/goalProcess.731abb48.png";